import qs from 'qs'
import { formatDate } from '../actions/dateUtility';


/**
 * If the student's commencement date is later than the current date then we
 * make the assumption that they are a commencing student. This means that we
 * display the first week to the student.
 *
 * If a student's commencement date is earlier than the current date then they
 * are a continuing student and we display the most recently elapsed week.
 *
 * @param {Array} sliderItems
 * @param {Boolean} groupByTeachingPeriod
 * @param {String} commencementDate
 */
export const calculateDefaultSlide = (sliderItems = [], groupByTeachingPeriod, commencementDate) => {
  if (sliderItems.length > 0) {
    if (groupByTeachingPeriod) {
      const elapsedSliderItems = getElapsedSliderItems(sliderItems)

      if (elapsedSliderItems.length > 0) {
        if (commencementDate) {
          const commencementDateObj = new Date(formatDateToAESTDate(new Date(formatDateLocale(commencementDate))))

          if (commencementDateObj.getFullYear() <= new Date().getFullYear()) {
            const currentElapsedSliderItem = elapsedSliderItems[elapsedSliderItems.length - 1]

            return currentElapsedSliderItem.id
          }
        }

        return elapsedSliderItems[0].id
      }
    }

    return sliderItems[0].id
  }

  return null
}

const getElapsedSliderItems = (sliderItems = []) => {
  return sliderItems
    .sort((a, b) => {
      const aStartDate = formatDateToAESTDate(a.startDate)
      const bStartDate = formatDateToAESTDate(b.startDate)

      if (new Date(aStartDate) < new Date(bStartDate)) {
        return -1
      }

      if (new Date(aStartDate) > new Date(bStartDate)) {
        return 1
      }

      return 0
    })
    .filter(sliderItem => {
      const startDate = formatDateToAESTDate(sliderItem.startDate)

      return new Date() >= new Date(startDate)
    })
}

export const formatDateLocale = dateArr => {
  if (dateArr.length === 3) {
    return `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`
  }
  return dateArr
}

export const formatDateToAESTDate = date => {
  return formatDate(date, 'MMMM d, yyyy')
}
